/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
import React from 'react';
import { CalendarAvailabilityDetail } from '../availabilityDetail/CalendarAvailabilityDetail';
import { OtherCalendarEventDetailDrawer } from '../otherCalendarEvents/OtherCalendarEventDetailDrawer';

interface CalendarDrawersProps {
  isAvailabilityDetailDrawerOpen: boolean;
  activeAvailability: any;
  calendarPresenter: any;
  activeRecruiterInfo: any;
  handleCloseAvailabilityDetail: () => void;

  isGoogleEventDetailDrawerOpen: boolean;
  selectedEventForDetail: any;
  handleCloseGoogleEventDetail: () => void;
}

export const CalendarDrawers = React.memo(
  ({
    isAvailabilityDetailDrawerOpen,
    activeAvailability,
    calendarPresenter,
    activeRecruiterInfo,
    handleCloseAvailabilityDetail,
    isGoogleEventDetailDrawerOpen,
    selectedEventForDetail,
    handleCloseGoogleEventDetail,
  }: CalendarDrawersProps) => {
    return (
      <>
        {isAvailabilityDetailDrawerOpen && activeAvailability && (
          <CalendarAvailabilityDetail
            selectedAvailability={activeAvailability}
            bookingList={calendarPresenter.listBookingByAppointmentId(activeAvailability?.id)}
            recruiterInfo={activeRecruiterInfo}
            isOpen={isAvailabilityDetailDrawerOpen}
            onClose={handleCloseAvailabilityDetail}
          />
        )}

        {isGoogleEventDetailDrawerOpen && selectedEventForDetail && (
          <OtherCalendarEventDetailDrawer
            eventDetail={selectedEventForDetail}
            isOpen={isGoogleEventDetailDrawerOpen}
            onClose={handleCloseGoogleEventDetail}
          />
        )}
      </>
    );
  },
);

CalendarDrawers.displayName = 'CalendarDrawers';
